import { Input, Component } from '@angular/core';

@Component({
    templateUrl: './notFound.component.html',
})
export class NotFoundComponent {
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/notFound/notFound.component.ts